import EVENT_METADATA_TYPES from './event-metadata-types'
import EVENT_SUBTYPES from './event-subtypes'

const EVENT_SUBTYPES_GROUPED_BY_EVENT_METADATA_TYPE = {
  [EVENT_METADATA_TYPES.LOCATION_TYPE]: [
    { value: EVENT_SUBTYPES.CREATE, label: 'Create' },
    { value: EVENT_SUBTYPES.UPDATE, label: 'Update' },
    { value: EVENT_SUBTYPES.DELETE, label: 'Delete' },
    { value: EVENT_SUBTYPES.SIMPLE_DETAILS, label: 'Update simple details' },
  ],

  [EVENT_METADATA_TYPES.CUISINE_TYPE]: [
    { value: EVENT_SUBTYPES.CREATE, label: 'Create' },
    { value: EVENT_SUBTYPES.UPDATE, label: 'Update' },
    { value: EVENT_SUBTYPES.DELETE, label: 'Delete' },
    { value: EVENT_SUBTYPES.SIMPLE_DETAILS, label: 'Update simple details' },
  ],

  [EVENT_METADATA_TYPES.COURSE_TYPE]: [
    { value: EVENT_SUBTYPES.CREATE, label: 'Create' },
    { value: EVENT_SUBTYPES.UPDATE, label: 'Update' },
    { value: EVENT_SUBTYPES.DELETE, label: 'Delete' },
    { value: EVENT_SUBTYPES.SIMPLE_DETAILS, label: 'Update simple details' },
  ],

  [EVENT_METADATA_TYPES.DISH_TYPE]: [
    { value: EVENT_SUBTYPES.CREATE, label: 'Create' },
    { value: EVENT_SUBTYPES.UPDATE, label: 'Update' },
    { value: EVENT_SUBTYPES.DELETE, label: 'Delete' },
    { value: EVENT_SUBTYPES.SIMPLE_DETAILS, label: 'Update simple details' },
    { value: EVENT_SUBTYPES.IMAGE_DETAILS, label: 'Update image details' },
    { value: EVENT_SUBTYPES.IGNORED_DETAILS, label: 'Update ignored details' },

    {
      value: EVENT_SUBTYPES.ADDITIONAL_INGREDIENTS_DETAILS_CREATE,
      label: 'Create additional ingredient',
    },

    {
      value: EVENT_SUBTYPES.ADDITIONAL_INGREDIENTS_DETAILS_DELETE,
      label: 'Delete additional ingredient',
    },

    {
      value: EVENT_SUBTYPES.ALTERNATIVE_INGREDIENTS_DETAILS_CREATE,
      label: 'Create replacement pair',
    },

    {
      value: EVENT_SUBTYPES.ALTERNATIVE_INGREDIENTS_DETAILS_DELETE,
      label: 'Delete replacement pair',
    },
  ],
  [EVENT_METADATA_TYPES.INGREDIENT]: [
    { value: EVENT_SUBTYPES.CREATE, label: 'Create' },
    { value: EVENT_SUBTYPES.UPDATE, label: 'Update' },
    { value: EVENT_SUBTYPES.DELETE, label: 'Delete' },

    {
      value: EVENT_SUBTYPES.SIMPLE_DETAILS,
      label: 'Update simple details',
    },

    {
      value: EVENT_SUBTYPES.COMPONENT_DETAILS_CREATE,
      label: 'Add component ingredient',
    },
    {
      value: EVENT_SUBTYPES.COMPONENT_DETAILS_DELETE,
      label: 'Delete component ingredient',
    },
    { value: EVENT_SUBTYPES.IS_WHOLE_FOOD, label: 'Update whole food flag' },
    {
      value: EVENT_SUBTYPES.EXTRA_DETAILS_INGREDIENTS_CREATE,
      label: 'Create extra ingredient',
    },
    {
      value: EVENT_SUBTYPES.EXTRA_DETAILS_INGREDIENTS_DELETE,
      label: 'Delete extra ingredient',
    },
    {
      value: EVENT_SUBTYPES.EXTRA_DETAILS_PHRASES_CREATE,
      label: 'Create phrase',
    },
    {
      value: EVENT_SUBTYPES.EXTRA_DETAILS_PHRASES_DELETE,
      label: 'Delete phrase',
    },
    {
      value: EVENT_SUBTYPES.OVERRIDES_DETAILS_CREATE,
      label: 'Create overrides ingredient',
    },
    {
      value: EVENT_SUBTYPES.OVERRIDES_DETAILS_DELETE,
      label: 'Delete overrides ingredient',
    },
    {
      value: EVENT_SUBTYPES.ALTERNATIVE_INGREDIENTS_DETAILS_CREATE,
      label: 'Create alternative ingredient',
    },
    {
      value: EVENT_SUBTYPES.ALTERNATIVE_INGREDIENTS_DETAILS_DELETE,
      label: 'Delete alternative ingredient',
    },
    {
      value: EVENT_SUBTYPES.RECEIVED_KEYWORD_FROM_DICTIONARY,
      label: 'Received keyword from dictionary',
    },
    {
      value: EVENT_SUBTYPES.RECEIVED_KEYWORD_FROM_INGREDIENT,
      label: 'Received keyword from ingredient',
    },
    {
      value: EVENT_SUBTYPES.SENT_KEYWORD_TO_DICTIONARY,
      label: 'Sent keyword to dictionary',
    },
    {
      value: EVENT_SUBTYPES.SENT_KEYWORD_TO_INGREDIENT,
      label: 'Sent keyword to ingredient',
    },
    { value: EVENT_SUBTYPES.CREATE_KEYWORD, label: 'Create keyword' },
    { value: EVENT_SUBTYPES.DELETE_KEYWORD, label: 'Delete keyword' },
    { value: EVENT_SUBTYPES.UPDATE_KEYWORD, label: 'Update keyword details' },
  ],
  [EVENT_METADATA_TYPES.DIET_CATEGORY]: [
    { value: EVENT_SUBTYPES.CREATE, label: 'Create' },
    { value: EVENT_SUBTYPES.UPDATE, label: 'Update' },
    { value: EVENT_SUBTYPES.DELETE, label: 'Delete' },

    {
      value: EVENT_SUBTYPES.SIMPLE_DETAILS,
      label: 'Update simple details',
    },
  ],
  [EVENT_METADATA_TYPES.DIET]: [
    { value: EVENT_SUBTYPES.CREATE, label: 'Create' },
    { value: EVENT_SUBTYPES.UPDATE, label: 'Update' },
    { value: EVENT_SUBTYPES.DELETE, label: 'Delete' },

    {
      value: EVENT_SUBTYPES.SIMPLE_DETAILS,
      label: 'Update simple details',
    },

    {
      value: EVENT_SUBTYPES.EXCLUDED_INGREDIENTS_CREATE,
      label: 'Create excluded ingredient',
    },

    {
      value: EVENT_SUBTYPES.EXCLUDED_ALLERGENS_CREATE,
      label: 'Create excluded allergen',
    },

    {
      value: EVENT_SUBTYPES.EXCLUDED_ALLERGENS_DELETE,
      label: 'Delete excluded allergen',
    },

    {
      value: EVENT_SUBTYPES.EXCLUDED_INGREDIENTS_DELETE,
      label: 'Delete excluded ingredient',
    },
  ],
  [EVENT_METADATA_TYPES.ALLERGEN]: [
    { value: EVENT_SUBTYPES.CREATE, label: 'Create' },
    { value: EVENT_SUBTYPES.UPDATE, label: 'Update' },
    { value: EVENT_SUBTYPES.DELETE, label: 'Delete' },
    { value: EVENT_SUBTYPES.SIMPLE_DETAILS, label: 'Update simple details' },

    {
      value: EVENT_SUBTYPES.INCLUDED_INGREDIENTS_CREATE,
      label: 'Create included ingredient',
    },

    {
      value: EVENT_SUBTYPES.INCLUDED_ALLERGENS_CREATE,
      label: 'Create included allergen',
    },

    {
      value: EVENT_SUBTYPES.INCLUDED_ALLERGENS_DELETE,
      label: 'Delete included allergen',
    },

    {
      value: EVENT_SUBTYPES.INCLUDED_INGREDIENTS_DELETE,
      label: 'Delete included ingredient',
    },
  ],

  [EVENT_METADATA_TYPES.DICTIONARY_WORD]: [
    { value: EVENT_SUBTYPES.CREATE, label: 'Create' },
    { value: EVENT_SUBTYPES.UPDATE, label: 'Update' },
    { value: EVENT_SUBTYPES.DELETE, label: 'Delete' },
    { value: EVENT_SUBTYPES.DETAILS, label: 'Update details' },

    {
      value: EVENT_SUBTYPES.SENT_DICTIONARY_WORD_TO_INGREDIENT,
      label: 'Sent dictionary word to ingredient',
    },

    {
      value: EVENT_SUBTYPES.RECEIVED_KEYWORD_FROM_INGREDIENT,
      label: 'Received ingredient keyword',
    },
  ],

  [EVENT_METADATA_TYPES.USER]: [
    { value: EVENT_SUBTYPES.CREATE, label: 'Create' },
    { value: EVENT_SUBTYPES.UPDATE, label: 'Update' },
    { value: EVENT_SUBTYPES.DELETE, label: 'Delete' },
    { value: EVENT_SUBTYPES.DETAILS, label: 'Update details' },
  ],
  [EVENT_METADATA_TYPES.CHALLENGE]: [
    { value: EVENT_SUBTYPES.CREATE, label: 'Create' },
    { value: EVENT_SUBTYPES.UPDATE, label: 'Update' },
    { value: EVENT_SUBTYPES.DELETE, label: 'Delete' },
    { value: EVENT_SUBTYPES.SIMPLE_DETAILS, label: 'Update simple details' },
    { value: EVENT_SUBTYPES.IMAGE_DETAILS, label: 'Update image details' },
    {
      value: EVENT_SUBTYPES.CHALLENGE_CUISINE_TYPES_CREATE,
      label: 'Add cuisine type to challenge',
    },
    {
      value: EVENT_SUBTYPES.CHALLENGE_CUISINE_TYPES_DELETE,
      label: 'Remove cuisine type from challenge',
    },
    {
      value: EVENT_SUBTYPES.CHALLENGE_DISH_TYPES_CREATE,
      label: 'Add dish type to challenge',
    },
    {
      value: EVENT_SUBTYPES.CHALLENGE_DISH_TYPES_DELETE,
      label: 'Remove dish type from challenge',
    },
  ],
  [EVENT_METADATA_TYPES.FOOD_MOOD]: [
    { value: EVENT_SUBTYPES.CREATE, label: 'Create' },
    { value: EVENT_SUBTYPES.UPDATE, label: 'Update' },
    { value: EVENT_SUBTYPES.DELETE, label: 'Delete' },
    { value: EVENT_SUBTYPES.SIMPLE_DETAILS, label: 'Update simple details' },
    { value: EVENT_SUBTYPES.IMAGE_DETAILS, label: 'Update image details' },
    {
      value: EVENT_SUBTYPES.FOOD_MOOD_DISH_TYPES_CREATE,
      label: 'Add dish type to food mood',
    },
    {
      value: EVENT_SUBTYPES.FOOD_MOOD_DISH_TYPES_DELETE,
      label: 'Remove dish type from food mood',
    },
  ],
}

export default EVENT_SUBTYPES_GROUPED_BY_EVENT_METADATA_TYPE
